
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/record-surround",
      function () {
        return require("private-next-pages/android/local/record-surround/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/record-surround"])
      });
    }
  